/**
 * Environment configuration
 */

// API base URL
const apiUrl = import.meta.env.VITE_API_URL || 'https://api.buscommander.com';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDJE6qxX6zgznACZG1wZyRdnFn9eBGXYmA",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "bus-commander-test.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "bus-commander-test",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "bus-commander-test.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "354078526074",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:354078526074:web:da11e8bca83b2474ca3224",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-5RP2S1WTBG"
};

// Debug mode
const debug = import.meta.env.DEV || false;

// Default export
export default {
  apiUrl,
  firebaseConfig,
  debug
}; 